<!-- 停机记录 -->
<style scoped="scoped" lang="scss">
.container {
  /* 使用网格布局，限制一行最多4个按钮 */
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-row-gap: 8px;
  grid-column-gap: 8px;
  /* 移除固定高度限制，让容器高度自适应内容 */
  padding: 8px;
  /* 添加边框和圆角美化 */
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background-color: #fafafa;
  /* 确保网格项目正确对齐 */
  align-items: start;
  justify-items: stretch;
}

/* 按钮容器不再需要滚动条样式，因为高度自适应内容 */

/* 响应式设计：在低分辨率下调整按钮布局 */
@media (max-width: 1200px) {
  .container {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .container {
    grid-template-columns: repeat(2, 1fr);
  }

  .fixed-width {
    font-size: 11px;
    padding: 3px 4px;
  }
}

.button-container {
  display: flex;
  justify-content: center;
  /* 水平居中对齐按钮 */
  align-items: center;
  /* 垂直居中对齐按钮 */
  flex-wrap: wrap;
  /* 换行排列按钮 */
  /* margin: 10px 0; */
  /* 调整上下间距，以适应您的需求 */
}

.fixed-width {
  /* 设置按钮宽度，确保文字完整显示 */
  width: 100%;
  height: 28px;
  /* 添加过渡效果 */
  transition: all 0.3s ease;
  /* 确保按钮文字不换行，显示全部内容 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* 设置合适的内边距，在4列布局下优化显示 */
  padding: 4px 6px;
  /* 设置最小宽度，确保按钮不会太窄 */
  min-width: 0;
  /* 确保按钮在网格中正确对齐 */
  box-sizing: border-box;
  margin: 0;
  /* 调整字体大小以适应更紧凑的布局 */
  font-size: 12px;
}

.fixed-width:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.tabs-container {
  display: flex;
  justify-content: center;
}

/* 优化tabs样式 */
.el-tabs {
  width: 100%;
}

/* 移除tabs内容区域的滚动条设置，避免双重滚动 */
.el-tabs__content {
  /* 让tabs内容区域自适应高度，移除固定高度和滚动条 */
  max-height: none;
  overflow: visible;
}

/* 优化弹窗内容区域 */
.dialog-content {
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  /* 确保内容能够正确滚动 */
  position: relative;
}

/* 为弹窗内容滚动条添加样式 */
.dialog-content::-webkit-scrollbar {
  width: 6px;
}

.dialog-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 选中状态的按钮样式 */
.is-selected {
  background-color: #409eff !important;
  color: #ffffff !important;
  border-color: #409eff !important;
}

.is-selected:hover {
  background-color: #66b1ff !important;
  border-color: #66b1ff !important;
}

/* 只读输入框样式已移至全局样式块 */

/* .custom-button {
  background-color: #00bfbf;
  color: #ffffff;
} */
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/equipment/exception/record/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_cross_select multiple :component="'web_base_equipment_list'" :ids.sync="yt.conditions.equipmentIdList"></yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('laiyuan')">
            <el-select filterable :clearable="true" v-model="yt.conditions.source">
              <el-option value="1" :label="$t('xitongshengcheng')"></el-option>
              <el-option value="2" :label="$t('rengongluru')"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('kaishishijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.startTime" :end.sync="yt.conditions.endTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('weiluruyuanyin')">
            <el-select filterable :clearable="true" v-model="yt.conditions.reason">
              <el-option value="true" :label="$t('shi')"></el-option>
              <el-option value="false" :label="$t('fou')"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('suoshuzuzhi')">
            <yi_data_select :max="1" :type="'organization'" :ids.sync="yt.conditions.orgId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('tingjiyuanyin')">
            <el-select filterable :clearable="true" v-model="yt.conditions.reasonId">
              <el-option v-for="item in reasonList" :value="item.id" :label="item.name + '｜' + reasonType(item.type)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('paixuguize')">
            <el-select filterable :clearable="true" v-model="yt.conditions.sort" @change="saveSortToCache">
              <el-option value="1" :label="$t('kaishishijianshengxu')"></el-option>
              <el-option value="2" :label="$t('kaishishijianjiangxu')"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="clear()">{{ $t('chongzhi') }}</el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, '55%'), getShutdownReasonTab()" type="primary" v-if="utils.checkPower('web_equipment_shutdown_record_create')">
          {{ $t('xinzeng') }}
        </el-button>
        <el-button
          size="mini"
          v-if="utils.checkPower('web_equipment_shutdown_record_setRule')"
          @click="
            yt.showEditDialog('shezhitongjiguize', null, '668px');
            getRule();
          "
        >
          {{ $t('shezhitongjiguize') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()" :loading="exportLoading"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>

      <!-- 处理后台返回的秒数转换为分钟数,保留小数点后一位,如果为整数页面显示为整数分钟,否则显示小数点 -->
      <template #wuzuoyeshichang(min)="scope">
        {{ timeToMin(scope.row.totalTime) }}
      </template>
      <!-- 人工确认时长(可编辑列) -->
      <template #rengongquerenshichang(min)="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="utils.checkPower('web_equipment_shutdown_record_manual_time') ? yt.showEditDialog('rengongquerenshichang', scope.row, 'w1') : {}" v-if="utils.checkPower('web_equipment_shutdown_record_update')">
              {{ timeToMin(scope.row.manualTime) }}
            </el-button>
          </el-col>
        </el-row>
      </template>

      <!-- 原因(可编辑列) -->
      <template #yuanyin="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" v-if="utils.checkPower('web_equipment_shutdown_record_update')" @click="yt.showEditDialog('xiugaiyuanyin', scope.row, '90%'), getShutdownReasonTab(), initModifyReasonDialog()">
              {{ scope.row.reasonName == null || scope.row.reasonName == '' ? $t('weiluru') : scope.row.reasonName }}
            </el-button>
          </el-col>
        </el-row>
      </template>

      <!-- 处理返回的'来源'值,如果值为1,取字符数组第一位(系统生成),值为2取数组第二位(人工录入),以此类推 ,注意: 数组第0位为空,目的是确保永远取不到第0位-->
      <template #laiyuan="scope">
        {{ ['', $t('xitongshengcheng'), $t('rengongluru')][scope.row.source] }}
      </template>

      <template #caozuo="scope">
        <el-button type="text" class="font-color-danger" @click="remove(scope.row)" v-if="!scope.row.reasonName">
          {{ $t('shanchu') }}
        </el-button>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <div class="dialog-content">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('shebeimingcheng')" required>
              <yi_cross_select :component="'web_base_equipment_list'" :multiple="true" :ids.sync="yt.editObj.equipmentIdList"></yi_cross_select>
            </el-form-item>
            <el-form-item :label="$t('kaishishijian')" required="required">
              <yi_time_input :type="'datetime'" :time.sync="yt.editObj.startTime"></yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('jieshushijian')" required="required">
              <yi_time_input :type="'datetime'" :time.sync="yt.editObj.endTime"></yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('yichangleixing')" required="required">
              <yi_dictionary_select :type="'EQUIPMENT_EXECTION_TYPE'" :ids.sync="yt.editObj.type"></yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input style="width:100%" v-model="yt.editObj.remark"></el-input>
            </el-form-item>
            <!-- <el-form-item :label="$t('tingjiyuanyin')">
							<yi_cross_select :component="'web_base_stop_reason_list'" :max="1"
								:ids.sync="yt.editObj.reasonId"></yi_cross_select>
						</el-form-item> -->
            <br />
            <el-form-item :label="$t('tingjiyuanyin')">
              <div style="width:180px"></div>
            </el-form-item>
            <div style="margin-bottom:40px;padding-left:80px;width:100%">
              <el-tabs>
                <el-tab-pane v-for="item in shutdownReasonList" :label="item.label" :key="item.label">
                  <div class="container">
                    <el-button
                      @click="yt.editObj.reasonId = vos.id"
                      :class="['fixed-width', 'custom-button', { 'is-selected': yt.editObj.reasonId === vos.id }]"
                      size="mini"
                      v-for="vos in item.faultStandardVOS"
                      :key="vos.id"
                      :title="vos.name"
                    >
                      {{ vos.name }}
                    </el-button>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-form>
        </div>
        <template slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/equipment/exception/record/batchCreateByEquipmentIdList')" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '停机记录-新增' } }">
            {{ $t('baocun') }}
          </el-button>
        </template>
      </template>
      <!-- 修改人工确认时间弹窗表单 -->
      <template v-if="yt.editObj.action == 'rengongquerenshichang'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('rengongquerenshichang')">
            <yi_number_input :precision="1" :start.sync="yt.editObj.manualTime" :type="'number'" :convert="'s-m'"></yi_number_input>
          </el-form-item>
          {{ $t('fenzhong') }}
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/equipment/exception/record/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 修改原因弹窗 -->
      <template v-if="yt.editObj.action == 'xiugaiyuanyin'">
        <div class="dialog-content">
          <el-form :inline="false" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <!-- 使用el-row和el-col实现2行2列布局 -->
            <el-row :gutter="16">
              <!-- 第一行 -->
              <el-col :span="12">
                <!-- 开始时间 -->
                <el-form-item :label="$t('kaishishijian')" required>
                  <yi_time_input
                    :type="'datetime'"
                    :time.sync="yt.editObj.startTime"
                    @change="calculateDuration"
                    :format="'yyyy-MM-dd HH:mm:ss'"
                  ></yi_time_input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!-- 结束时间 -->
                <el-form-item :label="$t('jieshushijian')" required>
                  <yi_time_input
                    :type="'datetime'"
                    :time.sync="yt.editObj.endTime"
                    @change="calculateDuration"
                    :format="'yyyy-MM-dd HH:mm:ss'"
                    :picker-options="endTimePickerOptions"
                  ></yi_time_input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="16">
              <!-- 第二行 -->
              <el-col :span="12">
                <!-- 无作业时长(min) -->
                <el-form-item :label="$t('wuzuoyeshichang(min)')">
                  <el-input
                    v-model="yt.editObj.totalTimeDisplay"
                    disabled
                    :placeholder="$t('zidongjisuan')"
                    class="readonly-input"
                    id="total-time-readonly-input"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!-- 人工确认时长(min) -->
                <el-form-item :label="$t('rengongquerenshichang(min)')">
                  <yi_number_input
                    :precision="1"
                    :start.sync="yt.editObj.manualTime"
                    :type="'number'"
                    :convert="'s-m'"
                    @change="onManualTimeChange"
                  ></yi_number_input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item>
              <el-tabs>
                <el-tab-pane v-for="item in shutdownReasonList" :label="item.label" :key="item.label">
                  <div class="container">
                    <el-button
                      @click="yt.editObj.reasonId = vos.id"
                      :class="['fixed-width', 'custom-button', { 'is-selected': yt.editObj.reasonId === vos.id }]"
                      size="mini"
                      v-for="vos in item.faultStandardVOS"
                      :key="vos.id"
                      :title="vos.name"
                    >
                      {{ vos.name }}
                    </el-button>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input style="width:100%" v-model="yt.editObj.remark" :placeholder="$t('qingxuanzetingjiyuanyin')"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <template slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="updateReasonRecord()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </template>
      </template>
      <!-- 设置统计规则弹窗 -->
      <template v-if="yt.editObj.action == 'shezhitongjiguize'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <div style="display: flex;justify-content: center;flex-wrap: nowrap;align-items: center">
            <el-form-item :label="$t('qingshezhilianxiwuzuoyetongjishichang')" required="required" label-width="250px">
              <yi_number_input :start.sync="yt.editObj.mins" :type="'number'"></yi_number_input>
            </el-form-item>
            <span style="margin-top: -15px;">{{ $t('fenzhong') }}</span>
          </div>
        </el-form>
        <template slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '停机记录-设置统计规则' } }">{{ $t('quxiao') }}</el-button>
          <el-button
            size="mini"
            @click="
              changeMins();
              yt.get(1);
            "
            :loading="yt.editObj.loading"
            type="primary"
          >
            {{ $t('baocun') }}
          </el-button>
        </template>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import XLSX from 'xlsx';
import reason_modification from '@@/pages/web/equipment/shutdown/reason_modification';
import { re } from 'mathjs';

export default {
  name: 'web_equipment_shutdown_list',
  components: {
    reason_modification
  },
  computed: {
    // 结束时间选择器的配置，确保结束时间大于开始时间
    endTimePickerOptions() {
      return {
        disabledDate: (time) => {
          if (!this.yt.editObj.startTime) return false;
          return time.getTime() <= this.yt.editObj.startTime;
        }
      };
    }
  },
  data() {
    return {
      reasonList: [],
      exportLoading: false,
      shutdownReasonList: [],
      list: [],
      standardList: [],
      oldRule: 0,
      mins: 0,
      columns: [
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name',
          width: 100
        },
        {
          label: 'suoshuzuzhi',
          prop: 'org.name',
          width: 100
        },
        {
          label: 'laiyuan',
          type: 'slot'
        },
        {
          // type: 'slot',
          label: 'yichangleixing',
          type: 'dictionary',
          prop: 'type',
          key: 'EQUIPMENT_EXECTION_TYPE'
        },
        {
          label: 'kaishishijian',
          prop: 'startTime',
          type: 'time'
        },
        {
          label: 'jieshushijian',
          prop: 'endTime',
          type: 'time'
        },
        {
          label: 'wuzuoyeshichang(min)',
          type: 'slot'
        },
        {
          label: 'rengongquerenshichang(min)',
          type: 'slot',
          width: 200
        },
        {
          label: 'yuanyin',
          type: 'slot'
        },
        {
          label: 'jiluren',
          prop: 'recorder.nickname'
        },
        {
          label: 'beizhu',
          prop: 'remark'
        },
        {
          label: 'caozuo',
          type: 'slot'
        }
      ],
      // 导出的字段配置
      exportColumns: [
        {
          label: 'shebeimingcheng',
          prop: 'equipmentName'
        },
        {
          label: 'laiyuan',
          prop: 'source',
          type: 'source'
        },
        {
          label: 'yichangleixing',
          type: 'dictionary',
          prop: 'type',
          key: 'EQUIPMENT_EXECTION_TYPE'
        },
        {
          label: 'kaishishijian',
          prop: 'startTime',
          type: 'time'
        },
        {
          label: 'jieshushijian',
          prop: 'endTime',
          type: 'time'
        },
        {
          label: 'wuzuoyeshichang(min)',
          prop: 'totalTime',
          type: 'min'
        },
        {
          label: 'rengongquerenshichang(min)',
          prop: 'manualTime',
          type: 'min'
        },
        {
          label: 'yuanyin',
          prop: 'reasonName',
          type: 'reason'
        },
        {
          label: 'jiluren',
          prop: 'recorder'
        },
        {
          label: 'beizhu',
          prop: 'remark'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      // 从localStorage读取缓存的排序规则
      const cachedSort = localStorage.getItem('equipment_shutdown_sort');
      const defaultSort = cachedSort || '1';

      // 确保 yt.conditions 对象存在
      if (!this.yt.conditions) {
        this.yt.conditions = {};
      }

      this.initTotalTime();

      // 使用 $set 来确保响应式更新
      this.$set(this.yt.conditions, 'startTime', this.dayjs().startOf('month').valueOf());
      this.$set(this.yt.conditions, 'endTime', this.dayjs().endOf('month').valueOf());
      this.$set(this.yt.conditions, 'sort', defaultSort);

      let response = this.http
        .get('web/equipment/exception/record/getRule')
        .then(response => {
          this.$set(this.yt.conditions, 'totalTime', response.data.mins * 60);
          this.yt.get(1);
        })
        .catch(c => {
          this.get(1);
        });
      // this.yt.editObj.mins = 60;
      // table列表接口请求参数
      //查询停机原因
      this.http.get('web/equipment/fault/standard/page?pageNum=1&pageSize=9999').then(response => {
        this.reasonList = response.data.rows;
      });
    }, 300);
  },

  methods: {
    reasonType(type) {
      return this.store.state.dictJsonAll['SHUTDOWN_REASON_CLASSIFICATION'][type];
    },
    // 导出Excel
    exportExcel() {
      this.exportLoading = true;
      let params = this.utils.copy(this.yt.conditions);
      params.pageSize = null;
      this.http
        .get('/web/equipment/exception/record/page', {
          params
        })
        .then(res => {
          let rows = res.data.rows;
          this.geneExcel(rows);
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },

    // 生成Excel
    geneExcel(data) {
      // 筛选出表头和prop
      let tableFirst = this.exportColumns.map(column => this.$t(column.label));
      // 顺序封装表格数据
      let tableArr = [];
      tableArr.push(tableFirst);
      for (let i = 0; i < data.length; i++) {
        let dataArr = [];
        for (let j = 0; j < this.exportColumns.length; j++) {
          const column = this.exportColumns[j];
          const v = data[i][column.prop];
          const value = this.formatField(v, column);
          dataArr.push(value);
        }
        tableArr.push(dataArr);
      }
      const worksheet = XLSX.utils.aoa_to_sheet(tableArr);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      XLSX.writeFile(workbook, `停机记录导出_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
    },
    // 格式化字段
    formatField(v, column) {
      const type = column.type;
      if (type) {
        switch (type) {
          case 'source': {
            if (v === 1) {
              return this.$t('xitongshengcheng');
            } else {
              return this.$t('rengongluru');
            }
          }
          case 'dictionary': {
            return this.$t(this.store.state.dictJsonAll[column.key][v]);
          }
          case 'time': {
            return this.dayjs(v).format('YYYY-MM-DD HH:mm:ss');
          }
          case 'min': {
            return this.timeToMin(v);
          }
          case 'reason': {
            return v || this.$t('weiluru');
          }
          default: {
            return v;
          }
        }
      }
      if (column.prop === 'recorder') {
        if (v && typeof v === 'object' && v.nickname) {
          return v.nickname;
        }
        return '';
      }
      return v;
    },
    clear() {
      // 使用 $set 来确保响应式更新
      this.$set(this.yt.conditions, 'totalTime', this.mins);
      this.$set(this.yt.conditions, 'startTime', this.dayjs().startOf('month').valueOf());
      this.$set(this.yt.conditions, 'endTime', this.dayjs().endOf('month').valueOf());
      this.$set(this.yt.conditions, 'sort', '1'); // 重置为默认排序规则
      // 清除排序规则缓存
      localStorage.removeItem('equipment_shutdown_sort');
      this.yt.clear({totalTime:this.mins,startTime:this.dayjs().startOf('month').valueOf(),endTime:this.dayjs().endOf('month').valueOf(),sort:'1'});
    },

    async remove(row) {
      this.$confirm(this.$t('shanchujiangbukehuifu,shifoujixu?'), this.$t('jinggao'), {
        confirmButtonText: this.$t('shanchu'),
        cancelButtonText: this.$t('no'),
        confirmButtonClass: 'el-button--danger',
        type: 'warning'
      })
        .then(() => {
          this.http
            .post('web/equipment/exception/record/delete', row)
            .then(res => {
              this.$message({ type: 'success', message: this.$t('chenggong') });
              this.yt.get(1);
            })
            .catch(error => {
              this.utils.errorMessage(this.$t(error));
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('yiquxiao')
          });
        });
    },

    async getShutdownReasonTab() {
      let response = await this.http.get('web/equipment/fault/standard/getShutdownReasonTab').then(response => {
        this.shutdownReasonList = response.data;
      });
    },

    // 初始化修改原因对话框的数据
    initModifyReasonDialog() {
      // 初始化无作业时长显示值
      if (this.yt.editObj.startTime && this.yt.editObj.endTime) {
        const timeDiff = this.yt.editObj.endTime - this.yt.editObj.startTime;
        const minutes = (timeDiff / (1000 * 60)).toFixed(1);
        this.$set(this.yt.editObj, 'totalTimeDisplay', minutes);
      } else {
        this.$set(this.yt.editObj, 'totalTimeDisplay', '');
      }
    },
    async initTotalTime() {
      let response = await this.http.get('web/equipment/exception/record/getRule').then(response => {
        if (response.data.mins != null && response.data.mins != undefined) {
          this.mins = response.data.mins * 60;
          // 使用 $set 来确保响应式更新
          this.$set(this.yt.conditions, 'totalTime', this.mins);
          this.$set(this.yt.conditions, 'startTime', this.dayjs().startOf('month').valueOf());
          this.$set(this.yt.conditions, 'endTime', this.dayjs().endOf('month').valueOf());
        }
      });
    },
    async changeMins() {
      let response = await this.http.post('web/equipment/exception/record/setRule', {
        mins: this.yt.editObj.mins
      });
      this.yt.editObj.loading = true;
      let result = await this.http
        .get('web/equipment/exception/record/getRule')
        .then(e => {
          this.mins = e.data.mins * 60;
          this.yt.conditions.totalTime = this.mins;
          this.yt.isShowEditDialog = false;
        })
        .finally(() => {
          this.yt.editObj.loading = false;
        });
      this.initTotalTime();
      this.yt.get(1);
    },
    async getRule() {
      let response = await this.http.get('web/equipment/exception/record/getRule');
      if (response.data.mins == null && response.data.mins == undefined) {
        this.$set(this.yt.editObj, 'mins', 60);
      } else {
        this.$set(this.yt.editObj, 'mins', response.data.mins);
      }
    },
    // 秒 -> 分钟
    timeToMin(time) {
      if (!time) {
        return 0;
      }
      const min = time / 60;
      return min.toFixed(1);
    },
    // 保存排序规则到缓存
    saveSortToCache() {
      if (this.yt.conditions.sort) {
        localStorage.setItem('equipment_shutdown_sort', this.yt.conditions.sort);
      } else {
        localStorage.removeItem('equipment_shutdown_sort');
      }
    },

    // 计算无作业时长
    calculateDuration() {
      if (this.yt.editObj.startTime && this.yt.editObj.endTime) {
        // 验证结束时间必须大于开始时间
        if (this.yt.editObj.endTime <= this.yt.editObj.startTime) {
          this.$message.error(this.$t('jieshushijianbixudayukaishishijian'));
          return;
        }

        // 计算时间差（毫秒）
        const timeDiff = this.yt.editObj.endTime - this.yt.editObj.startTime;
        // 转换为分钟，保留1位小数
        const minutes = (timeDiff / (1000 * 60)).toFixed(1);
        // 转换为秒（后端存储格式）
        const seconds = parseFloat(minutes) * 60;

        // 更新显示值
        this.$set(this.yt.editObj, 'totalTimeDisplay', minutes);
        // 同步更新实际的totalTime字段值（秒）
        this.$set(this.yt.editObj, 'totalTime', seconds);

        // 自动同步人工确认时长
        this.$set(this.yt.editObj, 'manualTime', seconds); // 使用相同的秒数
      }
    },

    // 人工确认时长变化时的处理
    onManualTimeChange() {
      // 当人工确认时长改变时，不需要自动同步，保持用户输入的值
    },

    // 更新原因记录的自定义方法
    updateReasonRecord() {
      // 确保totalTimeDisplay字段被包含在提交数据中
      const submitData = {
        ...this.yt.editObj,
        totalTimeDisplay: this.yt.editObj.totalTimeDisplay
      };

      // 使用自定义数据提交
      this.http.post('/web/equipment/exception/record/update', submitData)
        .then(response => {
          this.$message.success(this.$t('chenggong'));
          this.yt.isShowEditDialog = false;
          this.yt.get(1); // 刷新列表
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    }
  }
};
</script>

<!-- 全局样式，专门用于只读输入框 -->
<style>
/* 使用更具体的选择器确保样式生效 */
.el-dialog #total-time-readonly-input .el-input__inner,
.el-dialog__body #total-time-readonly-input .el-input__inner,
#total-time-readonly-input .el-input__inner {
  background-color: #f5f7fa !important;
  border-color: #e4e7ed !important;
  color: #c0c4cc !important;
  cursor: not-allowed !important;
}

.el-dialog #total-time-readonly-input .el-input__inner:focus,
.el-dialog__body #total-time-readonly-input .el-input__inner:focus,
#total-time-readonly-input .el-input__inner:focus {
  border-color: #e4e7ed !important;
  outline: none !important;
  box-shadow: none !important;
}

/* 备用方案：直接针对input元素 */
#total-time-readonly-input input {
  background-color: #f5f7fa !important;
  border-color: #e4e7ed !important;
  color: #c0c4cc !important;
  cursor: not-allowed !important;
}

#total-time-readonly-input input:focus {
  border-color: #e4e7ed !important;
  outline: none !important;
  box-shadow: none !important;
}
</style>
